var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c(`${_vm.iconName}`,{tag:"component",class:['zg-icon', {
    [`zg-icon--${_vm.color}`] : _vm.color,
    [`zg-icon--${_vm.size}`] : _vm.size,
    [`zg-icon--${_vm.rotate}`] : _vm.rotate
  }],attrs:{"icon":_vm.icon}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }